import { convertKeyToEnvironmentSymbol } from '../../../../workspace/shortcuts/modal/ShortcutKey';

/**
 * Builds the shortcut-key HTML used in Handsontable context-menu labels.
 */
export const getContextMenuShortcutHtml = (shortcuts: string[]): string => {
    let shortcutHtml = '';

    shortcuts.forEach((shortcut) => {
        const symbol = convertKeyToEnvironmentSymbol(shortcut);
        shortcutHtml += `<span class="shortcut-key ${symbol.length > 1 ? 'shortcut-long' : ''}">${symbol}</span>`;
    });

    return `<span class="shortcut-key-group">${shortcutHtml}</span>`;
};
